var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8892 4.73397C12.8892 4.32861 12.5606 4 12.1553 4C11.7499 4 11.4213 4.32861 11.4213 4.73397V11.2665L4.88924 11.2665C4.48388 11.2665 4.15527 11.5951 4.15527 12.0005C4.15527 12.4059 4.48388 12.7345 4.88924 12.7345L11.4213 12.7345L11.4213 19.266C11.4213 19.6714 11.7499 20 12.1553 20C12.5606 20 12.8892 19.6714 12.8892 19.266V12.7345L19.4213 12.7345C19.8267 12.7345 20.1553 12.4059 20.1553 12.0005C20.1553 11.5951 19.8267 11.2665 19.4213 11.2665L12.8892 11.2665L12.8892 4.73397Z",
    fill: "#D9D9D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGrey);
export default __webpack_public_path__ + "static/media/PlusGrey.da4e312810c445e74400dcd0f8f2027f.svg";
export { ForwardRef as ReactComponent };